import { InspectionItemStatus } from '@/services/types/inspection.types';

export interface CalendarEvent {
  id: string;
  title: string;
  start: Date;
  end: Date;
  status: InspectionItemStatus;
  statusDescription: string;
  inspectionItemId: string;
  proposalNumber: string;
  address: string;
  clientName?: string;
  inspectorName?: string;
  inspectorId?: string;
  providerName?: string;
  providerId?: string;
  scheduleId?: string;
  timeSlot?: number;
  timeSlotDescription?: string;
  notes?: string;
}

export interface CalendarFilters {
  providerId?: string;
  operationalProviderId?: string;
  inspectorId?: string;
  statuses?: InspectionItemStatus[];
  propertyTypeId?: string;
  city?: string;
}

export type CalendarView = 'month' | 'week' | 'day' | 'agenda';

export interface EventStyleGetter {
  style: React.CSSProperties;
  className?: string;
}

// Cores para status - sincronizadas com InspectionItemStatusColors
// Apenas status que aparecem no calendário (a partir de Agendado)
export const STATUS_COLORS: Partial<Record<InspectionItemStatus, { bg: string; border: string; text: string }>> = {
  // Status agendados (vistorias presenciais)
  [InspectionItemStatus.Agendado]: {
    bg: '#13c2c2',
    border: '#08979c',
    text: '#ffffff'
  },
  [InspectionItemStatus.CheckinRealizado]: {
    bg: '#eb2f96',
    border: '#c41d7f',
    text: '#ffffff'
  },

  // Status de conclusão
  [InspectionItemStatus.Finalizado]: {
    bg: '#1890ff',
    border: '#096dd9',
    text: '#ffffff'
  },
  [InspectionItemStatus.Cancelado]: {
    bg: '#f5222d',
    border: '#cf1322',
    text: '#ffffff'
  },
  [InspectionItemStatus.Frustrado]: {
    bg: '#d4380d',
    border: '#ad2102',
    text: '#ffffff'
  },

  // Status de televistoria
  [InspectionItemStatus.TelevistoriaAgendada]: {
    bg: '#722ed1',
    border: '#531dab',
    text: '#ffffff'
  },
  [InspectionItemStatus.TelevistoriaFinalizada]: {
    bg: '#13c2c2',
    border: '#08979c',
    text: '#ffffff'
  },

  // Status pós-inspeção (fluxo de laudo)
  [InspectionItemStatus.AguardandoGeracaoLaudo]: {
    bg: '#eb2f96',
    border: '#c41d7f',
    text: '#ffffff'
  },
  [InspectionItemStatus.AguardandoRevisaoPrestadora]: {
    bg: '#1890ff',
    border: '#096dd9',
    text: '#ffffff'
  },
  [InspectionItemStatus.LaudoNegadoPorPrestadora]: {
    bg: '#fa8c16',
    border: '#d46b08',
    text: '#ffffff'
  },
  [InspectionItemStatus.AguardandoRevisaoBanco]: {
    bg: '#722ed1',
    border: '#531dab',
    text: '#ffffff'
  },
  [InspectionItemStatus.LaudoNegadoPorBanco]: {
    bg: '#ff4d4f',
    border: '#cf1322',
    text: '#ffffff'
  },
  [InspectionItemStatus.CorrecaoPeloInspetorBanco]: {
    bg: '#faad14',
    border: '#d48806',
    text: '#ffffff'
  },
  [InspectionItemStatus.LaudoAceitoPeloBanco]: {
    bg: '#52c41a',
    border: '#389e0d',
    text: '#ffffff'
  },
  [InspectionItemStatus.LaudoDevolvido]: {
    bg: '#ff7a45',
    border: '#d4380d',
    text: '#ffffff'
  },
};
